// extracted by mini-css-extract-plugin
export default {"wrapper":"input-icon-golden_wrapper__yVtLR","icon":"input-icon-golden_icon__YIzec","text":"input-icon-golden_text__Qj4J3"};